<template>
  <div class="container">
    <div v-if="loading">
      <div id="loader">
        <font-awesome-icon icon="spinner" spin />
      </div>
    </div>

    <h6>Dueño beneficiario - LFPIORPI</h6>

    <label>
      Conforme a lo establecido en la Ley Federal para la Prevención e Identificación de Operaciones con Recursos de Procedencia
      Ilícita, su Reglamento y Reglas de Carácter General, manifiesto, bajo protesta de decir verdad, que:
    </label>

    <div>
      <b-button :id="`popover-1`" variant="info" size="sm">
        <i class="fa fa-question"></i>
      </b-button>
      <b-popover
        :target="`popover-1`"
        :placement="'left'"
        title="LEY FEDERAL PARA LA PREVENCIÓN E IDENTIFICACIÓN DE OPERACIONES CON
        RECURSOS DE PROCEDENCIA ILÍCITA."
        triggers="hover focus"
      >
        <b>BENEFICIARIO CONTROLADOR</b>
        es la
        <b>PERSONA FÍSICA</b>
        o
        <b>GRUPO DE PERSONAS FÍSICAS</b>
        que:
        <ol type="a" class="alpha-paren-list">
          <li>
            Directamente o por medio de alguna persona Cliente o Usuaria obtiene, en última instancia, el beneficio de goce, uso,
            disfrute, aprovechamiento o disposición del bien o servicio derivado de la realización de un acto u operación con
            quien realice una Actividad Vulnerable, o
          </li>
          <li>
            Ejerce el control efectivo en última instancia de aquella persona moral que, en su carácter de Cliente o Usuaria,
            lleve a cabo actos u operaciones con quien realice una Actividad Vulnerable, así como las personas por cuenta de
            quienes celebra alguno de ellos.
          </li>
        </ol>

        Se entiende que una persona o grupo de personas controla de manera efectiva en última instancia a una persona moral
        cuando, a través de la titularidad de valores, por contrato o cualquier otro acto, en términos de las Reglas de Carácter
        General aplicables, puede:

        <ol type="i" class="alpha-paren-list">
          <li>
            Imponer, directa o indirectamente, decisiones en las asambleas generales de accionistas, socios u órganos
            equivalentes, o nombrar o destituir a la mayoría de los consejeros, administradores o sus equivalentes;
          </li>
          <li>
            Mantener la titularidad de los derechos que permitan, directa o indirectamente, ejercer el voto respecto de más del
            veinticinco por ciento del capital social, o
          </li>
          <li>Dirigir, directa o indirectamente, la administración, la estrategia o las principales políticas de la misma.</li>
        </ol>
      </b-popover>
    </div>

    <b-form-group label="Seleccione una opción">
      <b-form-radio-group id="radio-group-1" v-model="clausulaLfpiorpiId" name="radio-options-1" :disabled="false">
        <!-- First item with separator -->
        <b-form-radio :value="clausulas_lfpiorpi[0].value" class="mb-3 pb-2" :disabled="clausulas_lfpiorpi[0].disabled">
          <span v-html="clausulas_lfpiorpi[0].html"></span>
        </b-form-radio>

        <!-- Remaining items -->
        <b-form-radio
          v-for="(item, index) in clausulas_lfpiorpi.slice(1)"
          :key="index"
          :value="item.value"
          :disabled="item.disabled"
        >
          <span v-html="item.html"></span>
        </b-form-radio>
      </b-form-radio-group>
    </b-form-group>

    <b-collapse id="collapse-1" :visible="clausulaLfpiorpiId != 1" class="mt-2">
      <div class="mt-4">
        <span>Dueño beneficiario</span>
        <b-button :disabled="false" variant="success" class="btn-fill spaceL" size="sm" @click="addBeneficiario(1)">+</b-button>
      </div>

      <div class="row">
        <div class="col-12">
          <b-table hover :fields="fieldsCuadro" :items="beneficiariosControladoresLfpiorpiComputed">
            <template #cell(acciones)="{ item }">
              <div class="d-flex justify-content-end align-items-center">
                <b-button
                  variant="info"
                  size="sm"
                  v-b-tooltip.hover
                  title="Información base"
                  class="editBtn"
                  :disabled="false"
                  @click="editBeneficiario(item.index)"
                >
                  <b-icon-info />
                </b-button>
                <b-button
                  variant="warning"
                  size="sm"
                  v-b-tooltip.hover
                  title="Llenar información"
                  class="editBtn"
                  :disabled="false"
                  @click="editCompareciente(item.index)"
                >
                  <b-icon-pencil />
                </b-button>
                <b-button
                  variant="danger"
                  size="sm"
                  v-b-tooltip.hover
                  title="Eliminar"
                  class=""
                  :disabled="false"
                  @click="predeleteBeneficiario(item.index)"
                >
                  <b-icon-trash />
                </b-button>
              </div>
            </template>
          </b-table>
        </div>
      </div>
    </b-collapse>

    <h6>Dueño beneficiario - Código Fiscal</h6>

    <label>Conforme a lo establecido en el Código Fiscal de la Federación, manifiesto, bajo protesta de decir verdad, que:</label>

    <div>
      <b-button :id="`popover-2`" variant="info" size="sm">
        <i class="fa fa-question"></i>
      </b-button>
      <b-popover
        :target="`popover-2`"
        :placement="'left'"
        title="Artículo 32-B Quáter CFF. Para efectos de este Código se entenderá por beneficiario controlador a la persona física o grupo de personas físicas que:"
        triggers="hover focus"
        :content="`I. Directamente o por medio de otra u otras o de cualquier acto jurídico, obtiene u obtienen el beneficio derivado de su participación en una persona moral, un fideicomiso o cualquier otra figura jurídica, así como de cualquier otro acto jurídico, o es quien o quienes en última instancia ejerce o ejercen los derechos de uso, goce, disfrute, aprovechamiento o disposición de un bien o servicio o en cuyo nombre se realiza una transacción, aun y cuando lo haga o hagan de forma contingente.
II. Directa, indirectamente o de forma contingente, ejerzan el control de la persona moral, fideicomiso o cualquier otra figura jurídica.
Se entiende que una persona física o grupo de personas físicas ejerce el control cuando, a través de la titularidad de valores, por contrato o por cualquier otro acto jurídico, puede o pueden:
a) Imponer, directa o indirectamente, decisiones en las asambleas generales de accionistas, socios u órganos equivalentes, o nombrar o destituir a la mayoría de los consejeros, administradores o sus equivalentes.
b) Mantener la titularidad de los derechos que permitan, directa o indirectamente, ejercer el voto respecto de más del 15% del capital social o bien.
c) Dirigir, directa o indirectamente, la administración, la estrategia o las principales políticas de la persona moral, fideicomiso o cualquier otra figura jurídica.`"
      ></b-popover>

      <b-button :id="`popover-3`" variant="primary fill" size="sm" style="margin-left: 10px !important">Criterios</b-button>
      <b-popover
        :target="`popover-3`"
        :placement="'left'"
        title="CRITERIOS PARA LA DETERMINACIÓN DE LA CONDICIÓN DE BENEFICIARIO CONTROLADOR DE LAS PERSONAS MORALES"
        triggers="hover focus"
        :content="`Para los efectos del artículo 32-B Ter del CFF, en la identificación de los beneficiarios controladores, se deberá aplicar lo dispuesto en el artículo 32-B Quáter, fracciones I y II, incisos a), b) y c) de forma sucesiva, como criterios para su determinación.
Para efectos de la obtención de la información a que se refiere el artículo 32-B Ter del CFF, las personas morales deberán identificar, verificar y validar la información sobre los beneficiarios controladores, indicando los porcentajes de participación en el capital de la persona moral, incluyendo la información relativa a la cadena de titularidad, en los casos en que el beneficiario controlador lo sea indirectamente. Se entiende por cadena de titularidad el supuesto en que se ostente la propiedad indirecta, a través de otras personas morales. Asimismo, las personas morales también deberán identificar, verificar y validar la información relativa a la cadena de control, en los casos en los que el beneficiario controlador lo sea por medios distintos a la propiedad. Se entiende por cadena de control el supuesto en que se ostente el control indirectamente, a través de otras personas morales, fideicomisos o cualquier otra figura jurídica.
Cuando no se identifique a persona física alguna bajo los criterios establecidos en esta regla, en relación con el artículo 32-B Quáter del CFF, se considerará como beneficiario controlador a la persona física que ocupe el cargo de administrador único de la persona moral o equivalente. En caso de que la persona moral cuente con un consejo de administración u órgano equivalente, cada miembro de dicho consejo se  considerará como beneficiario controlador de la persona moral.`"
      ></b-popover>
    </div>

    <b-form-group label="Seleccione una opción">
      <b-form-radio-group id="radio-group-2" v-model="clausulaCffId" name="radio-options-2">
        <!-- First item with separator -->
        <b-form-radio :value="clausulas_cff[0].value" class="mb-3 pb-2" :disabled="clausulas_cff[0].disabled">
          <span v-html="clausulas_cff[0].html"></span>
        </b-form-radio>

        <!-- Remaining items -->
        <b-form-radio v-for="(item, index) in clausulas_cff.slice(1)" :key="index" :value="item.value" :disabled="item.disabled">
          <span v-html="item.html"></span>
        </b-form-radio>
      </b-form-radio-group>
    </b-form-group>

    <b-collapse id="collapse-2" :visible="[2, 4].includes(clausulaCffId)" class="mt-2">
      <div class="mt-4">
        <span>Dueño beneficiario</span>
        <b-button :disabled="false" variant="success" class="btn-fill spaceL" size="sm" @click="addBeneficiario(2)">+</b-button>
      </div>

      <div class="row">
        <div class="col-12">
          <b-table hover :fields="fieldsCuadro" :items="beneficiariosControladoresCffComputed">
            <template #cell(acciones)="{ item }">
              <div class="d-flex justify-content-end align-items-center">
                <b-button
                  variant="info"
                  size="sm"
                  v-b-tooltip.hover
                  title="Información base"
                  class="editBtn"
                  :disabled="false"
                  @click="editBeneficiario(item.index)"
                >
                  <b-icon-info />
                </b-button>
                <b-button
                  variant="warning"
                  size="sm"
                  v-b-tooltip.hover
                  title="Llenar información"
                  class="editBtn"
                  :disabled="false"
                  @click="editCompareciente(item.index)"
                >
                  <b-icon-pencil />
                </b-button>
                <b-button
                  variant="danger"
                  size="sm"
                  v-b-tooltip.hover
                  title="Eliminar"
                  class=""
                  :disabled="false"
                  @click="predeleteBeneficiario(item.index)"
                >
                  <b-icon-trash />
                </b-button>
              </div>
            </template>
          </b-table>
        </div>
      </div>
    </b-collapse>

    <b-row>
      <b-col class="d-flex justify-content-end">
        <b-button class="btn-fill" @click="changeInnerComponent('regresar')">Regresar</b-button>
        <b-button class="btn-fill orange-btn" @click="changeInnerComponent('guardar')">Guardar</b-button>
      </b-col>
    </b-row>

    <b-modal no-close-on-backdrop centered hide-footer id="modal-beneficiario" title="" size="xl">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(putBeneficiario)">
          <ModalBeneficiario
            :currentBeneficiario="currentBeneficiario"
            :clausulaLfpiorpiId="clausulaLfpiorpiId"
            :clausulaCffId="clausulaCffId"
            @submit.prevent
          />
        </form>
      </ValidationObserver>
    </b-modal>
    <b-modal no-close-on-backdrop centered hide-footer id="modal-confirm-dialog">
      <h4 class="text-center">¿Seguro que quiere borrar el Dueño Beneficiario seleccionado?</h4>
      <h5 class="text-center">Se eliminarán todos los datos.</h5>
      <b-button class="mt-3" variant="danger" @click="hideModalConfirmDialog">Cancelar</b-button>
      <b-button class="mt-3 float-right" variant="primary" @click="deleteBeneficiario">OK</b-button>
    </b-modal>
    <b-modal no-close-on-backdrop centered hide-footer id="modal-borrar-beneficiario" @close="revertSelectClausula1hanlder">
      <h4 class="text-center">
        Si selecciona la primer opción se borrará la infomación de los dueños beneficiarios registrados, ¿Desea continuar?
      </h4>
      <h5 class="text-center">Se eliminarán los datos guardados.</h5>
      <b-button class="mt-3" variant="danger" @click="revertSelectClausula1hanlder">Cancelar y mantener opción previa</b-button>
      <b-button class="mt-3 float-right" variant="primary" @click="continueSelectClausula1hanlder">
        Continuar y borrar los datos
      </b-button>
    </b-modal>
  </div>
</template>

<script>
import ModalBeneficiario from "@/views/clients/procesos/constitucion/infoBase/modales/ModalBeneficiario.vue";

import { AccionistasApi, BeneficiariosControladoresApi, ComparecientesApi, ClientesApi } from "@/api";
import Storage from "@/utils/storage";

const storage = new Storage();

export default {
  name: "BeneficiarioControlador",

  components: {
    ModalBeneficiario,
  },

  created() {
    this.clausulaLfpiorpiId = this.accionista.clausula_lfpiorpi_id;
    this.clausulaCffId = this.accionista.clausula_cff_id;
    this.getBeneficiariosControladores();
  },

  props: {
    accionista: { type: Object },
  },

  computed: {
    clausulas_lfpiorpi() {
      return [
        {
          html: "<span style='color: black;'><b>ACTÚO POR MI PROPIO DERECHO</b>, por lo que directamente y en última instancia, obtengo el beneficio del servicio derivado de la realización del acto u operación contratada. Por lo anterior, <b>NO</b> tengo conocimiento de beneficiario controlador distinto a quien declara.</span>",
          value: 1,
          disabled: this.accionista.persona == "Moral",
        },
        {
          html: "<span style='color: black;'><b>ACTUO POR ORDEN Y CUENTA de UNA PERSONA FÍSICA</b> o <b>GRUPO DE PERSONAS FÍSICAS</b> distintas a quien declara, quien(es) en última instancia, obtiene(n) el beneficio del servicio derivado de la realización del acto u operación contratada. Por lo anterior, <b>SI</b> tengo conocimiento de beneficiario controlador, siendo las personas físicas que a continuación se enlistan.</span>",
          value: 2,
        },
        {
          html: "<span style='color: black;'><b>ACTÚO EN REPRESENTACIÓN DE UNA PERSONA MORAL</b>, y <b>SI</b> tengo conocimiento del Beneficiario Controlador pues conozco a la persona física o grupo de personas físicas que mantienen la titularidad de los derechos que permiten, directa o indirectamente, ejercer el voto respecto de más del 25% del capital social.</span>",
          value: 3,
        },
        {
          html: "<span style='color: black;'><b>ACTÚO EN REPRESENTACIÓN DE UNA PERSONA MORAL</b>, y <b>SI</b> tengo conocimiento del Beneficiario Controlador pues conozco a la persona física o grupo de personas físicas que: (i) imponen, directa o indirectamente, decisiones en las asambleas generales de accionistas o de socios; (ii) o pueden nombrar o destituir a los administradores; o (iii) dirigen, directa o indirectamente, la estrategia o las principales políticas de la persona moral.</span>",
          value: 4,
        },
        {
          html: "<span style='color: black;'><b>ACTÚO EN REPRESENTACIÓN DE UNA PERSONA MORAL</b>, y <b>SI</b> tengo conocimiento del Beneficiario Controlador pues conozco a la persona física o grupo de personas físicas que dirigen, directa o indirectamente, la administración de la persona moral.</span>",
          value: 5,
        },
      ];
    },
    clausulas_cff() {
      return [
        {
          html: "<span style='color: black;'><b>ACTÚO POR MI PROPIO DERECHO</b>, por lo que <b>NO</b> hay beneficiario controlador distinto al que realiza la presente declaración.</span>",
          value: 1,
          disabled: this.accionista.persona == "Moral",
        },
        {
          html: "<span style='color: black;'><b>SI</b> tengo conocimiento del Beneficiario Controlador, pues conozco a la persona física o grupo de personas físicas que mantienen la titularidad de los derechos que permiten, directa o indirectamente, ejercer el voto respecto de más del 15% del capital social.</span>",
          value: 2,
        },
        {
          html: "<span style='color: black;'><b>NO</b> tengo conocimiento del beneficiario controlador bajo los criterios establecidos en la regla 2.8.1.20. de la RMF. No obstante lo anterior, tengo conocimiento de la forma en la que está compuesta la administración de mi representada, siendo las personas que declaré bajo las reglas de la LFPIORPI.</span>",
          value: 3,
        },
        {
          html: "<span style='color: black;'><b>SI</b> tengo conocimiento de beneficiarios controladores adicionales, distintos a los declarados bajo las reglas de la LFPIORPI.</span>",
          value: 4,
        },
        {
          html: "<span style='color: black;'><b>No</b> tengo conocimiento de beneficiarios controladores adicionales, distintos a los declarados en la Sección 1, bajo las reglas de la LFPIORPI</span>",
          value: 5,
        },
      ];
    },
    fieldsCuadro() {
      return [
        { key: "index", label: "#", class: "text-center" },
        { key: "nombre", label: "Nombre", class: "text-center" },
        { key: "paterno", label: "Paterno", class: "text-center" },
        { key: "materno", label: "Materno", class: "text-center" },
        { key: "acciones", label: "Acciones", class: "text-center" },
      ];
    },

    beneficiariosControladoresLfpiorpiComputed() {
      return this.beneficiariosControladores.filter((b) => b.tipo_beneficiario === 1);
    },

    beneficiariosControladoresCffComputed() {
      return this.beneficiariosControladores.filter((b) => b.tipo_beneficiario === 2);
    },
  },

  watch: {
    clausulaLfpiorpiId(newValue, oldValue) {
      if (newValue === 1 && this.beneficiariosControladores.filter((b) => b.tipo_beneficiario === 1).length > 0) {
        this.showModalBorrarBeneficiario();
        this.previousClausulaLfpiorpiId = oldValue;
      } else {
        this.clausulaLfpiorpiId = newValue;
        this.updateAccionista();
      }
    },
    clausulaCffId(newValue, oldValue) {
      if ([1, 3, 5].includes(newValue) && this.beneficiariosControladores.filter((b) => b.tipo_beneficiario === 2).length > 0) {
        this.showModalBorrarBeneficiario();
        this.previousClausulaCffId = oldValue;
      } else {
        this.clausulaCffId = newValue;
        this.updateAccionista();
      }
    },
  },

  data() {
    return {
      loading: false,
      visibleCollapse1: false,
      visibleCollapse2: false,

      clausulaLfpiorpiId: null,
      previousClausulaLfpiorpiId: null,
      clausulaCffId: null,
      previousClausulaCffId: null,

      beneficiariosControladores: [],
      currentBeneficiario: {
        index: null,
        compareciente_id: null,
        nombre: null,
        paterno: null,
        materno: null,
        es_beneficiario_controlador_directo: null,
        es_tenedor_mas_25_porciento_capital_social: null,
        porcentaje_capital_social: null,
        tiene_cargo_directivo_administracion: null,
        cargo: null,
        tipo_beneficiario: 0,
      },
      currentBeneficiarioIndex: null,
    };
  },

  methods: {
    async getBeneficiariosControladores() {
      try {
        this.loading = true;
        const { value } = await BeneficiariosControladoresApi.list({
          page: 0,
          registersPerPage: 0,
          accionistaComparecienteId: this.accionista.id,
        });

        let i = 1;
        for (const beneficiario of value) {
          const comparecienteInfoBase = await ComparecientesApi.getComparecienteNombreCompleto(beneficiario.compareciente_id);
          beneficiario.nombre = comparecienteInfoBase.nombre;
          beneficiario.paterno = comparecienteInfoBase.paterno;
          beneficiario.materno = comparecienteInfoBase.materno;
          beneficiario.index = i++;
        }

        this.beneficiariosControladores = value;
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },

    showModalConfirmDialog() {
      this.$bvModal.show("modal-confirm-dialog");
    },

    hideModalConfirmDialog() {
      this.$bvModal.hide("modal-confirm-dialog");
    },

    showModalBeneficiario() {
      this.$bvModal.show("modal-beneficiario");
    },

    hideModalBeneficiario() {
      this.$bvModal.hide("modal-beneficiario");
    },

    showModalBorrarBeneficiario() {
      this.$bvModal.show("modal-borrar-beneficiario");
    },

    hideModalBorrarBeneficiario() {
      this.$bvModal.hide("modal-borrar-beneficiario");
    },

    addBeneficiario(tipoBeneficiario) {
      this.currentBeneficiario = {
        id: 0,
        creado: new Date(),
        actualizado: new Date(),
        activo: true,
        compareciente_id: null,
        accionista_id: null,
        accionista_compareciente_id: null,
        constitucion_sociedades_id: null,
        es_beneficiario_controlador_directo: null,
        es_tenedor_mas_25_porciento_capital_social: null,
        porcentaje_capital_social: null,
        tiene_cargo_directivo_administracion: null,
        cargo: null,
        tipo_beneficiario: tipoBeneficiario,
      };
      this.showModalBeneficiario();
    },

    editBeneficiario(index) {
      const i = this.beneficiariosControladores.findIndex((b) => b.index === index);
      this.currentBeneficiario = this.beneficiariosControladores[i];
      this.showModalBeneficiario();
    },

    putBeneficiario() {
      this.hideModalBeneficiario();

      if (!this.currentBeneficiario.index) {
        this.createBeneficiarioCompareciente()
          .then(() => {
            this.currentBeneficiario.index = this.beneficiariosControladores.length + 1;
            const b = structuredClone(this.currentBeneficiario);
            this.beneficiariosControladores.push(b);
          })
          .then(() => {
            this.currentBeneficiario = null;
          });
      } else {
        const index = this.beneficiariosControladores.findIndex((b) => (b.index = this.currentBeneficiario.index));
        this.editBeneficiarioCompareciente(this.currentBeneficiario.index)
          .then(() => {
            const b = structuredClone(this.currentBeneficiario);
            this.beneficiariosControladores.splice(index, 1, b);
          })
          .then(() => {
            this.currentBeneficiario = null;
          });
      }
    },

    predeleteBeneficiario(index) {
      this.currentBeneficiarioIndex = index;
      this.showModalConfirmDialog();
    },

    deleteBeneficiario() {
      const index = this.beneficiariosControladores.findIndex((o) => o.index === this.currentBeneficiarioIndex);
      this.beneficiariosControladores.splice(index, 1);
      this.hideModalConfirmDialog();
    },

    async createBeneficiarioCompareciente() {
      try {
        this.loading = true;

        const clienteEmail = storage.getItem("user");
        const { id } = await ClientesApi.clienteId(clienteEmail);
        const newCompareciente = await ComparecientesApi.create({
          nombre: this.currentBeneficiario.nombre,
          paterno: this.currentBeneficiario.paterno,
          materno: this.currentBeneficiario.materno,
          cliente_id: id,
          cat_servicio_id: 1,
          servicio_id: this.accionista.servicio_id,
          visible: 1,
          personna: "Física",
          actua_derecho_propio: true,
        });
        const newBeneficiario = await BeneficiariosControladoresApi.create({
          compareciente_id: newCompareciente.id,
          accionista_compareciente_id: this.accionista.id,
          constitucion_sociedades_id: this.accionista.servicio_id,
          es_beneficiario_controlador_directo: this.currentBeneficiario.es_beneficiario_controlador_directo,
          es_tenedor_mas_25_porciento_capital_social: this.currentBeneficiario.es_tenedor_mas_25_porciento_capital_social,
          porcentaje_capital_social: Number(this.currentBeneficiario.porcentaje_capital_social),
          tiene_cargo_directivo_administracion: this.currentBeneficiario.tiene_cargo_directivo_administracion,
          cargo: this.currentBeneficiario.cargo,
          tipo_beneficiario: this.currentBeneficiario.tipo_beneficiario,
        });

        this.currentBeneficiario.id = newBeneficiario.id;
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },

    async editBeneficiarioCompareciente(index) {
      try {
        this.loading = true;

        const i = this.beneficiariosControladores.findIndex((o) => o.index === index);
        const beneficiario = this.beneficiariosControladores[i];

        await ComparecientesApi.partialEdit(beneficiario.compareciente_id, {
          nombre: this.currentBeneficiario.nombre,
          paterno: this.currentBeneficiario.paterno,
          materno: this.currentBeneficiario.materno,
        });
        const editedBeneficiario = await BeneficiariosControladoresApi.edit(beneficiario.id, {
          es_beneficiario_controlador_directo: this.currentBeneficiario.es_beneficiario_controlador_directo,
          es_tenedor_mas_25_porciento_capital_social: this.currentBeneficiario.es_tenedor_mas_25_porciento_capital_social,
          porcentaje_capital_social: Number(this.currentBeneficiario.porcentaje_capital_social),
          tiene_cargo_directivo_administracion: this.currentBeneficiario.tiene_cargo_directivo_administracion,
          cargo: this.currentBeneficiario.cargo,
          tipo_beneficiario: this.currentBeneficiario.tipo_beneficiario,
        });
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },

    editCompareciente(index) {
      const i = this.beneficiariosControladores.findIndex((o) => o.index === index);
      const beneficiario = this.beneficiariosControladores[i];

      this.$router.push({
        name: "EditComparecientes",
        params: { id: beneficiario.compareciente_id },
        query: {
          proceso: 1,
          procesoAccion: "editconstitucion",
          procesoId: this.accionista.constitucion_sociedades_id,
          accion: "edit",
        },
      });
    },

    async updateAccionista() {
      try {
        this.loading = true;

        this.accionista.clausula_lfpiorpi_id = this.clausulaLfpiorpiId;
        this.accionista.clausula_cff_id = this.clausulaCffId;

        await AccionistasApi.partialEditByComparecienteId(this.accionista.id, {
          clausula_lfpiorpi_id: this.clausulaLfpiorpiId,
          clausula_cff_id: this.clausulaCffId,
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    changeInnerComponent(action) {
      if (action === "guardar") {
      }
      this.$emit("changeInnerComponent", action);
    },

    revertSelectClausula1hanlder() {
      this.clausulaLfpiorpiId = this.previousClausulaLfpiorpiId;
      this.clausulaCffId = this.previousClausulaCffId;
      this.hideModalBorrarBeneficiario();
    },

    async continueSelectClausula1hanlder() {
      try {
        this.loading = true;

        await this.updateAccionista();

        if (this.clausulaLfpiorpiId === 1) {
          const beneficiarios = this.beneficiariosControladores.filter((b) => b.tipo_beneficiario === 1);

          for (const beneficiario of beneficiarios) {
            await BeneficiariosControladoresApi.delete(beneficiario.id);
          }

          this.beneficiariosControladores = this.beneficiariosControladores.filter((b) => b.tipo_beneficiario !== 1);
        }
        if (this.clausulaCffId === 1) {
          const beneficiarios = this.beneficiariosControladores.filter((b) => b.tipo_beneficiario === 2);

          for (const beneficiario of beneficiarios) {
            await BeneficiariosControladoresApi.delete(beneficiario.id);
          }

          this.beneficiariosControladores = this.beneficiariosControladores.filter((b) => b.tipo_beneficiario !== 2);
        }
      } catch (error) {
      } finally {
        this.loading = false;
        this.hideModalBorrarBeneficiario();
      }
    },
  },
};
</script>

<style scoped>
.spaceL {
  margin-left: 1%;
}

.alpha-paren-list {
  list-style-type: lower-alpha;
}

.alpha-paren-list li::marker {
  content: counter(list-item, lower-alpha) ") ";
}
</style>
